<div class="manual-select-container">
  <ul>
    <li class="section-row">
      <p class="section-header">{{ "nouns.insert-separate-procedures" | translate }}</p>
    </li>

    <ng-container *ngFor="let procedure of proceduresArray.controls; let i = index">
      <ng-container *ngIf="!procedure.get('protocolId')?.value">
        <li class="section-row selected-procedure-row" *ngIf="procedure.get('id')?.value">
          <span class="selected-procedure-name">
            <span
              class="type-label"
              [class.apac]="procedure.get('type')?.value === 'APAC'"
              [class.sadt]="procedure.get('type')?.value === 'SADT'"
            >
              {{ procedure.get("type")?.value }}
            </span>
            {{ procedure.get("code")?.value }} - {{ procedure.get("description")?.value }}
          </span>
          <button type="button" class="remove-btn" (click)="removeProcedure(i)" [title]="'actions.remove' | translate">
            <span>×</span>
          </button>
        </li>

        <li class="section-row procedure-row" *ngIf="!procedure.get('id')?.value">
          <div class="custom-select-wrapper">
            <div class="select-trigger" (click)="toggleDropdown(i, $event)">
              <span class="select-placeholder">{{ "nouns.procedures" | translate }}</span>
              <span class="select-arrow" [class.open]="activeRowIndex === i">▼</span>
            </div>

            <div class="select-panel" *ngIf="activeRowIndex === i" (click)="$event.stopPropagation()">
              <div class="search-box">
                <div class="input-container">
                  <img src="assets/icons/search.svg" class="search-icon" alt="Search" />
                  <input
                    class="search-input"
                    [formControl]="filteringCtrl"
                    [placeholder]="'actions.search' | translate"
                  />
                </div>
              </div>

              <div class="loader-container --inline" *ngIf="isSearching">
                <div class="loader-spinner"></div>
              </div>

              <div class="options-list" *ngIf="!isSearching">
                <div
                  class="option-item"
                  *ngFor="let option of filteredOptions | async"
                  [class.disabled]="option.disabled"
                  (click)="!option.disabled && onProcedureManualSelected(option.value, i)"
                >
                  {{ option.description }}
                </div>

                <div class="empty-state" *ngIf="!(filteredOptions | async)?.length">
                  {{ "sessions-details.procedure-not-found" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="row-actions">
            <button
              type="button"
              class="action-btn"
              [class.add-btn]="isLastManualItem(i)"
              [class.remove-btn]="!isLastManualItem(i)"
              (click)="isLastManualItem(i) ? addProcedure() : removeProcedure(i)"
            >
              <span>{{ isLastManualItem(i) ? "+" : "×" }}</span>
            </button>
          </div>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</div>
